import apiRequest from "../services/request";

const POST = "POST",
  GET = "GET",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
  URLENCODED = "urlencoded",
  FORMDATA = "formdata",
  JSONDATA = "json";

export default {
  // --- AUTH ---
  login: (data) => apiRequest(POST, "/api/admin/auth/login", data, URLENCODED),
  logout: () => apiRequest(POST, "/api/admin/auth/logout"),

  // --- PERSONAL ---
  me: () => apiRequest(GET, "/api/auth/me"),

  // --- USERS ---
  get_users: (params) => apiRequest(GET, "/api/users/", params),
  get_staff: () => apiRequest(GET, "/api/users/"),
  create_staff: (data) => apiRequest(POST, "/api/users/staff", data, JSONDATA),
  deactivate: (id) => apiRequest(PATCH, `/api/users/deactivate/${id}`),
  update_staff: (id, data) =>
    apiRequest(PATCH, `/api/users/staff/${id}`, data, JSONDATA),

  // --- CLASSES ---
  get_classes: (params) => apiRequest(GET, "/api/classes", params),
  get_class: (id) => apiRequest(GET, `/api/classes/${id}`),
  create_class: (data) => apiRequest(POST, "/api/classes", data, JSONDATA),
  update_class: (id, data) =>
    apiRequest(PATCH, `/api/classes/${id}`, data, JSONDATA),
  delete_class: (id) => apiRequest(DELETE, `/api/classes/${id}`),
  toggle_class: (id) =>
    apiRequest(PATCH, `/api/classes/${id}/toggle`, {}, JSONDATA), // эсвэл PATCH

  // --- SCHEDULES ---
  get_schedules: (params) => apiRequest(GET, "/api/schedules", params),
  create_schedules_bulk: (data) =>
    apiRequest(POST, "/api/schedules", data, JSONDATA),
  update_schedule: (id, data) =>
    apiRequest(PUT, `/api/schedules/${id}`, data, JSONDATA),
  delete_schedule: (id) => apiRequest(DELETE, `/api/schedules/${id}`),
  set_schedule_closed: (id, is_closed) =>
    apiRequest(PATCH, `/api/schedules/${id}/close`, { is_closed }, JSONDATA),

  // --- BUNDLES ---
  get_bundles: () => apiRequest(GET, "/api/bundles/"),
  create_bundle: (data) => apiRequest(POST, "/api/bundles/", data, JSONDATA),
  // update_bundle: (id, data) =>
  //   apiRequest(PUT, `/api/bundles/${id}`, data, JSONDATA),
  update_bundle: (id, data) =>
    apiRequest(PATCH, `/api/bundles/${id}`, data, JSONDATA),
  delete_bundle: (id) => apiRequest(DELETE, `/api/bundles/${id}`),
  give_bundle: (bundle_id, data) =>
    apiRequest(POST, `/api/bundles/${bundle_id}/assign`, data, JSONDATA),
  extend_bundle: (bundle_id, data) =>
    apiRequest(POST, `/api/bundles/${bundle_id}/extend`, data, JSONDATA),
  cancel_bundle: (user_bundle_id) =>
    apiRequest(POST, `/api/bundles/${user_bundle_id}/cancel`),
  toggle_feature: (id) =>
    apiRequest(PATCH, `/api/bundles/${id}/feature`, {}, JSONDATA),
  get_yoga_times: (id) => apiRequest(GET, `/api/bundles/${id}/yoga-times`),

  // --- UPLOAD ---
  upload_image: (formData) =>
    apiRequest(POST, "/api/uploads/image", formData, FORMDATA),

  // --- DASHBOARD ---
  general: () => apiRequest(GET, "/api/dash/"),

  // --- BANNER ---
  get_images: () => apiRequest(GET, "/api/banner/images"),
  get_banners: () => apiRequest(GET, "/api/banner"),
  add_banners: (data) => apiRequest(POST, "/api/banner/bulk", data, JSONDATA),
  delete_banner: (id) => apiRequest(DELETE, `/api/banner/${id}`),

  // --- ROLES ---
  get_permissions: () => apiRequest(GET, "/api/roles/permissions"),
  get_roles: () => apiRequest(GET, "/api/roles"),
  create_role: (data) => apiRequest(POST, "/api/roles", data, JSONDATA),
  update_role: (id, data) =>
    apiRequest(PATCH, `/api/roles/${id}`, data, JSONDATA),
  delete_role: (id) => apiRequest(DELETE, `/api/roles/${id}`),
  assign_role: (userId, role_id) =>
    apiRequest(PATCH, `/api/roles/users/${userId}`, { role_id }, JSONDATA),
};
